import _objectSpread from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorValues from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regeneratorValues.js";
import _regeneratorKeys from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regeneratorKeys.js";
import _slicedToArray from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import userPopMixin from "@/views/system/index/mixin/userPopMixin";
import dayjs from "dayjs";
export default {
  mixins: [userPopMixin],
  data: function data() {
    return {
      searchForm: {
        page: 1,
        count: 20,
        auth_status: -1,
        phone: this.$route.query.phone || ""
      },
      // 搜索表单

      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0,
      // 总数

      dialogVisible: false,
      // 弹窗
      form: {
        phone: "",
        scene: "fraud"
      },
      // 弹窗表单

      authSceneRiskCodeList: [],
      // 授权场景风险码
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        }
      }
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var badgeNumber;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            badgeNumber = document.querySelector("#userforce-real-name .wlc-menu-badge-number");
            if (badgeNumber && badgeNumber.textContent > 0) {
              _this.searchForm.auth_status = 2;
            }
            _this.getData();
            _this.getAuthSceneRiskCodeList();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    handleDateChange: function handleDateChange(value) {
      if (value && value.length === 2) {
        var _value = _slicedToArray(value, 2),
          start = _value[0],
          end = _value[1];
        var endDate = dayjs(end).hour(23).minute(59).second(59);
        var startTimeStamp = dayjs(start).valueOf();
        var endTimeStamp = endDate.valueOf();
        this.searchForm.timeArr = [startTimeStamp, endTimeStamp];
        this.getData("search");
      }
    },
    getAuthSceneLabel: function getAuthSceneLabel(scene) {
      var _this$authSceneRiskCo;
      return (_this$authSceneRiskCo = this.authSceneRiskCodeList.find(function (item) {
        return item.scene == scene;
      })) === null || _this$authSceneRiskCo === void 0 ? void 0 : _this$authSceneRiskCo.label;
    },
    addDialog: function addDialog() {
      this.form = {
        phone: "",
        scene: "fraud"
      };
      this.dialogVisible = true;
    },
    getAuthSceneRiskCodeList: function getAuthSceneRiskCodeList() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this2.$api.getAuthSceneRiskCodeList();
            case 1:
              res = _context2.v;
              _this2.authSceneRiskCodeList = res.data;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    setUserForcAuth: function setUserForcAuth() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _yield$_this3$$api$ge, user, res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return _this3.$api.getUserInfoByPhone({
                phone: _this3.form.phone
              });
            case 1:
              _yield$_this3$$api$ge = _context4.v;
              user = _yield$_this3$$api$ge.data;
              if (!user.auth_info_id) {
                _context4.n = 2;
                break;
              }
              _this3.$confirm("该用户已绑定实名信息，确认继续操作？", "注意", {
                confirmButtonText: "继续",
                cancelButtonText: "取消",
                type: "warning"
              }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
                var res;
                return _regenerator().w(function (_context3) {
                  while (1) switch (_context3.n) {
                    case 0:
                      _context3.n = 1;
                      return _this3.$api.setUserForcAuth(_this3.form);
                    case 1:
                      res = _context3.v;
                      _this3.dialogVisible = false;
                      _this3.$message.success("操作成功");
                    case 2:
                      return _context3.a(2);
                  }
                }, _callee3);
              }))).catch(function () {});
              _context4.n = 4;
              break;
            case 2:
              _context4.n = 3;
              return _this3.$api.setUserForcAuth(_this3.form);
            case 3:
              res = _context4.v;
              _this3.dialogVisible = false;
              _this3.$message.success("操作成功");
            case 4:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    audit: function audit(row, status) {
      var _this4 = this;
      this.$confirm("确认操作， 是否继续?", status == 0 ? "取消实名" : status == 3 ? "通过实名" : "拒绝实名", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var code;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return _this4.$api.setForcAuthStatus({
                id: row.id,
                auth_status: status
              });
            case 1:
              _this4.$message.success("操作成功");
              _this4.getData();
              code = '';
              if (status == 3) {
                code = 'pass';
              } else if (status == 4) {
                code = 'reject';
              } else if (status == 0) {
                code = 'cancel';
              }
              // 操作上报
              _this4.$operationLog.push({
                code: code,
                userId: row.id,
                operationType: "user_force_realname"
              });
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))).catch(function () {});
    },
    getUserDeviceRiskBatch: function getUserDeviceRiskBatch() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var userIds, res, _loop, key, _t, _t2;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              userIds = [];
              _this5.tableData.forEach(function (item) {
                if (userIds.indexOf(item.id) == -1) {
                  userIds.push(item.id);
                }
              });
              _context7.n = 1;
              return _this5.$api.getUserDeviceRiskBatch({
                user_ids: userIds.join(",")
              });
            case 1:
              res = _context7.v;
              _loop = /*#__PURE__*/_regenerator().m(function _loop(key) {
                return _regenerator().w(function (_context6) {
                  while (1) switch (_context6.n) {
                    case 0:
                      _this5.tableData.forEach(function (item, index) {
                        if (item.id == key) {
                          _this5.$set(item, "deviceRiskInfo", res.data[key]);
                        }
                      });
                    case 1:
                      return _context6.a(2);
                  }
                }, _loop);
              });
              _t = _regeneratorKeys(res.data);
            case 2:
              if ((_t2 = _t()).done) {
                _context7.n = 4;
                break;
              }
              key = _t2.value;
              return _context7.d(_regeneratorValues(_loop(key)), 3);
            case 3:
              _context7.n = 2;
              break;
            case 4:
              return _context7.a(2);
          }
        }, _callee6);
      }))();
    },
    getUsersTagList: function getUsersTagList() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var userIds, res, _loop2, key, _t3, _t4;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              userIds = [];
              _this6.tableData.forEach(function (item) {
                userIds.push(item.id);
              });
              _context9.n = 1;
              return _this6.$api.getUsersTagList({
                top: 5,
                user_id: userIds.join(",")
              });
            case 1:
              res = _context9.v;
              _loop2 = /*#__PURE__*/_regenerator().m(function _loop2(key) {
                return _regenerator().w(function (_context8) {
                  while (1) switch (_context8.n) {
                    case 0:
                      _this6.tableData.forEach(function (item) {
                        if (item.id == key) {
                          _this6.$set(item, "userTag", res.data[key]);
                        }
                      });
                    case 1:
                      return _context8.a(2);
                  }
                }, _loop2);
              });
              _t3 = _regeneratorKeys(res.data);
            case 2:
              if ((_t4 = _t3()).done) {
                _context9.n = 4;
                break;
              }
              key = _t4.value;
              return _context9.d(_regeneratorValues(_loop2(key)), 3);
            case 3:
              _context9.n = 2;
              break;
            case 4:
              return _context9.a(2);
          }
        }, _callee7);
      }))();
    },
    pageChange: function pageChange(pn) {
      this.searchForm.page = pn;
      this.getData();
    },
    getData: function getData(type) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var _this7$searchForm$tim, _this7$searchForm$tim2;
        var params, _this7$searchForm$tim3, _this7$searchForm$tim4, res;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              if (type === "search") {
                _this7.searchForm.page = 1;
              }
              _this7.tableLoading = true;
              params = _objectSpread({}, _this7.searchForm);
              if ((_this7$searchForm$tim = _this7.searchForm.timeArr) !== null && _this7$searchForm$tim !== void 0 && _this7$searchForm$tim[0] || (_this7$searchForm$tim2 = _this7.searchForm.timeArr) !== null && _this7$searchForm$tim2 !== void 0 && _this7$searchForm$tim2[1]) {
                params.auth_set_time_start = ((_this7$searchForm$tim3 = _this7.searchForm.timeArr) === null || _this7$searchForm$tim3 === void 0 ? void 0 : _this7$searchForm$tim3[0]) / 1000;
                params.auth_set_time_end = ((_this7$searchForm$tim4 = _this7.searchForm.timeArr) === null || _this7$searchForm$tim4 === void 0 ? void 0 : _this7$searchForm$tim4[1]) / 1000;
              }
              delete params.timeArr;
              delete params.time;
              _context0.n = 1;
              return _this7.$api.getForceAuthList(params);
            case 1:
              res = _context0.v;
              _this7.tableData = res.data;
              _this7.total = res.page.total;
              _this7.tableLoading = false;
              _this7.getUsersTagList();
              _this7.getUserDeviceRiskBatch();
              _this7.getUserListByIds(_this7.tableData, "id");
            case 2:
              return _context0.a(2);
          }
        }, _callee8);
      }))();
    }
  }
};